t = require('app/scripts/views/internal/teacup-with-helpers')('card_detail')

module.exports = t.renderable (selector, icon, text, isCustom) ->
  t.a ".button-link.#{selector}", {
    href: '#',
    title: t.l(text)
  }, ->
    t.icon icon, { class: t.classify('icon-custom': isCustom) }
    t.span -> t.format text
